export default __webpack_public_path__ + "static/lowfi-1096a122f89769e10f4f1d7c5f1edfd0.png";